var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReflectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#553B8A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.562 20.713a7.36 7.36 0 0 0-4.726-6.833c-.913-.352-1.95-.552-3.102-.552h-6.458v3.754h6.36c.457 0 .88.057 1.264.16 1.95.52 2.954 2.208 2.954 3.52 0 1.313-1.005 2.999-2.954 3.52-.385.104-.805.161-1.264.161h-6.757a1.877 1.877 0 1 0 0 3.754h6.855c1.154 0 2.19-.2 3.102-.552a7.357 7.357 0 0 0 4.726-6.833v-.099z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.047 13.336h-4.77v3.754h5.827v-3.754h-1.057z",
    fill: "#fff",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m27.968 31.342-2.131-3.7-1.936-3.361-4.147-7.2-1.524-2.645a2.212 2.212 0 0 0-1.857-1.108h-.127a2.21 2.21 0 0 0-1.851 3.318l4.49 7.796 2.162 3.753 3.086 5.358a2.215 2.215 0 0 0 3.836-2.21h-.001z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m27.966 31.342-2.131-3.7-1.936-3.361-4.147-7.2-1.524-2.645a2.212 2.212 0 0 0-1.857-1.108h-.127a2.232 2.232 0 0 0-.495.071c.361.188.673.478.891.856l1.525 2.646 4.146 7.198 1.937 3.363 2.13 3.699a2.215 2.215 0 0 1-1.356 3.247 2.215 2.215 0 0 0 2.946-3.066h-.002z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 24.438h-3.003a1.877 1.877 0 1 0 0 3.753h5.164l-2.161-3.753z",
    fill: "#fff",
    opacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m23.898 24.282 1.936 3.363a7.34 7.34 0 0 0 3.147-2.314l-2.509-3.097a4.02 4.02 0 0 1-2.575 2.048z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReflectIcon);
export default __webpack_public_path__ + "static/media/reflectIcon.c3bc9e993aab1ccc31301bb74aab663d.svg";
export { ForwardRef as ReactComponent };